import { useState } from 'react'
import { CheckboxCheckedIcon, CheckboxUncheckedIcon, LayersIcon } from '../UnifiedControlPlane/assets/icons/Icons';
import { Visualization } from '../modelling/utils/visualization';
import * as Cesium from "cesium";

interface LayerState {
  All_Layers: boolean;
  AOI: boolean;
  Ground_Station: boolean;
  Satellite: boolean;
}

interface LayerItem {
  label: string;
  id: keyof LayerState;
  prefix: string;
}

interface LayersFilterProps {
  viewer: Cesium.Viewer | null;
  isActive?: boolean;
}



function LayersFilter({ viewer, isActive = false }: LayersFilterProps) {
  const [isAllSelected, setIsAllSelected] = useState<boolean>(true);
  const [layers, setLayers] = useState<LayerState>({
    All_Layers: true,
    AOI: true,
    Ground_Station: true,
    Satellite: true
  });

  const layersName: LayerItem[] = [
    { label: "AOI", id: "AOI", prefix: "aoi_" },
    { label: "Satellite", id: "Satellite", prefix: "oo_" },
    { label: "Ground Station", id: "Ground_Station", prefix: "gs_" },
  ];

  const toggleSelectAll = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.stopPropagation();
    const newisAllSelected = !isAllSelected;
    setIsAllSelected(newisAllSelected);

    if (newisAllSelected) {
      setLayers({
        All_Layers: true, AOI: true, Ground_Station: true, Satellite: true
      })
      showAllLayers()
    } else {
      setLayers({
        All_Layers: false, AOI: false, Ground_Station: false, Satellite: false
      })
      hideAllLayers()
    }
  }

  const toggleSelectLayer = (e: React.MouseEvent<HTMLDivElement>, item: LayerItem): void => {
    e.stopPropagation();
    const newLayers = { ...layers, [item.id]: !layers[item.id] };
    setLayers(newLayers)
    const allLayersSelected = layersName.every(layer => newLayers[layer.id]);
    setIsAllSelected(allLayersSelected);

    if (newLayers[item.id]) {
      showLayerByPrefix(item.prefix)
    } else {
      hideLayerByPrefix(item.prefix)
    }
  }

  const showAllLayers = (): void => {
    if (!viewer) return;
    const allEntities: Cesium.Entity[] = Visualization.getAllEntitiesFromDataSources(viewer);
    allEntities.forEach((entity) => {
      if (entity && entity.id) {
        const hasValidPrefix = layersName.some((layer) => entity.id.startsWith(layer.prefix))
        if (hasValidPrefix) {
          entity.show = true;
        }
      }
    })
    Visualization.requestRenderViewer(viewer)
  }

  const hideAllLayers = (): void => {
    if (!viewer) return;
    const allEntities: Cesium.Entity[] = Visualization.getAllEntitiesFromDataSources(viewer);
    allEntities.forEach((entity) => {
      if (entity && entity.id) {
        const hasValidPrefix = layersName.some((layer) => entity.id.startsWith(layer.prefix))
        if (hasValidPrefix) {
          entity.show = false;
        }
      }
    })
    Visualization.requestRenderViewer(viewer)
  }

  const showLayerByPrefix = (prefix: string): void => {
    if (!viewer) return;

    const allEntities: Cesium.Entity[] = Visualization.getAllEntitiesFromDataSources(viewer);
    allEntities.forEach((entity) => {
      if (entity && entity.id && entity.id.startsWith(prefix)) {
        entity.show = true;
      }
    })
    Visualization.requestRenderViewer(viewer)
  }

  const hideLayerByPrefix = (prefix: string): void => {
    if (!viewer) return;

    const allEntities: Cesium.Entity[] = Visualization.getAllEntitiesFromDataSources(viewer);
    allEntities.forEach((entity) => {
      if (entity && entity.id && entity.id.startsWith(prefix)) {
        entity.show = false;
      }
    })
    Visualization.requestRenderViewer(viewer)
  }

  return (
    <div className={`layersFeaturesList ${isActive ? "active" : ""}`}>
      <div className="listHeader">
        <div className='headerIcon'>
          <LayersIcon width={16} height={16} isActive={true} />
        </div>
        <span className='headerText'>Layer</span>
      </div>
      <div className='listItem' onClick={(e) => toggleSelectAll(e)}>
        {isAllSelected ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon />}
        <span className='listItemText'>All Layers</span>
      </div>
      {layersName.map((item) => (
        <div key={item.id} className='listItem' onClick={(e) => toggleSelectLayer(e, item)}>
          {layers[item.id] ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon />}
          <div className="listItemText">{item.label}</div>
        </div>
      ))}
    </div>
  )
}

export default LayersFilter